import { Component } from '@angular/core';

@Component({
  selector: 'app-student-transport',
  imports: [],
  templateUrl: './student-transport.component.html',
  styleUrl: './student-transport.component.scss'
})
export class StudentTransportComponent {

}
